import "focus-visible";
import { AppState, Auth0Provider } from "@auth0/auth0-react";
import ReactDOM from "react-dom/client";
import { RouterProvider } from "react-router";
import "./index.css";
import router from "./router";
import { initSentry, SENTRY_DSN } from "./sentry";
import { ReactQueryProvider } from "./services/providers/ReactQueryProvider";
import { ToastProvider } from "./services/providers/ToastProvider";
import { AuthGuard } from "./AuthGuard";

if (SENTRY_DSN) {
  initSentry();
}

ReactDOM.createRoot(document.getElementById("root") as HTMLElement).render(
  <Auth0Provider
    domain={import.meta.env.VITE_AUTH0_DOMAIN}
    clientId={import.meta.env.VITE_AUTH0_CLIENT_ID}
    cacheLocation="memory"
    useRefreshTokens={true}
    onRedirectCallback={(appState?: AppState) => {
      router.navigate(appState?.returnTo ?? window.location.pathname, {
        replace: true,
      });
    }}
    authorizationParams={{
      redirect_uri: window.location.origin,
      audience: import.meta.env.VITE_AUTH0_AUDIENCE,
      scope: "profile offline_access",
    }}
  >
    <AuthGuard>
      <ReactQueryProvider>
        <ToastProvider>
          <RouterProvider router={router} />
        </ToastProvider>
      </ReactQueryProvider>
    </AuthGuard>
  </Auth0Provider>,
);
